import '../../../../styles/globals.css'
import { Typography } from '@mui/material'
import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';


function NoteExpiryGridPiece(props) {

    const [expiryTime, setExpiryTime] = useState(props.note.expireTime);

    const [timeTillExpiry, setTimeTillExpiry] = useState(0);

    // expiry time is format 2023-09-13T21:17:27.679636 return in format :00:00:00

    useEffect(() => {
        setTimeDiff();
        const interval = setInterval(() => {
            setTimeDiff();
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    function setTimeDiff() {
        // get now time
        var now = new Date();

        var expiry = new Date(props.note.expireTime);
        var timeDiff = expiry - now;
        var timeDiffSeconds = Math.floor(timeDiff / 1000);
        var timeDiffMinutes = Math.floor(timeDiffSeconds / 60);
        var timeDiffHours = Math.floor(timeDiffMinutes / 60);


        // format 00:00:00:00 (ensure trailing zeroes remain)

        if (timeDiffMinutes < 1 && timeDiffHours < 1) {
            var timeTillExpiry = "less than a minute left";
            setTimeTillExpiry(timeTillExpiry);
        }
        if (timeDiffHours < 1) {
            var timeTillExpiry = (timeDiffMinutes % 60 < 10 ? "0" + timeDiffMinutes % 60 : timeDiffMinutes % 60);
            setTimeTillExpiry(timeTillExpiry + " mins");
        }
        else {
            var timeTillExpiry = (timeDiffHours) + " hrs, " + (timeDiffMinutes % 60 < 10 ? "0" + timeDiffMinutes % 60 : timeDiffMinutes % 60) + " mins";
            setTimeTillExpiry(timeTillExpiry);
        }
    }

    if (props.note.isNewsletterNote) {
        return (
            <div />
        );
    }

    return (
        <Grid item xs={6} sm={6} sx={{ textAlign: "left", paddingLeft: "1rem", padding: "0.5rem" }}>
            <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.0rem", fontSize: "0.775rem", marginTop: "0.2rem", marginLeft: "0.5rem", color: "rgba(256, 256, 256, 0.6)" }}>
                {props.neverExpires != null && props.neverExpires ? "expires: never" : "expires: " + timeTillExpiry}
            </Typography>
        </Grid>
    );
}

export default NoteExpiryGridPiece;
